// src/legal/legalApi.js — GET /api/v1/legal/current (v221).
//
// ⛔ Deliberately bare `fetch`, NOT apiFetch: the route is PUBLIC and /set-password calls it before any login
// (apiFetch would attach a stale token / tenant and, on a 401, wipe the session). Same pattern as
// auth/passwordResetApi.js. `cache: 'no-store'`: never a cached answer (the BE sends no-store too).
// A transport failure is coded NETWORK; any non-2xx is a buildApiError (status + code); the caller blocks on both.
import { API_V1, getSessionHeaders } from '../services/api/config.js';
import { buildApiError } from '../context/parseApiError.js';
import { normalizeTerms } from './termsModel.js';

export async function fetchCurrentTerms() {
  let res;
  try {
    res = await fetch(`${API_V1}/legal/current`, {
      method: 'GET',
      cache: 'no-store',
      headers: { ...getSessionHeaders() },
    });
  } catch {
    const err = new Error('NETWORK');
    err.code = 'NETWORK';
    throw err;
  }
  if (!res.ok) {
    const parsed = await res.json().catch(() => ({}));
    throw buildApiError(parsed, res.status);
  }
  return normalizeTerms(await res.json());
}
